import http from "@/api";
import { RequestRes } from "@/api/type";

// 获取邮箱验证码
export const getEmailCode = (email:string)=>{
    return http.get('/api/login/sendCode',{params:{email}}).then(res=>{
        return res
    }) as Promise<RequestRes>
}
// 邮箱登录
export const loginEmail = (params:{email:string,code:string})=>{
    return http.post('/api/login/email',params).then(res=>{
        return res
    }) as Promise<RequestRes>
}
// 手机密码登录
export const loginPhone = (params:{phone:string,password:string})=>{
    return http.post('/api/login/phone',params).then(res=>{
        return res
    }) as Promise<RequestRes>
}
// 检测是否登录
export const loginCheck = ()=>{
    return http.get('/api/login/check').then(res=>{
        return res
    }) as Promise<RequestRes>
}